import { RouteObject, createBrowserRouter } from 'react-router-dom'
import { routePaths } from '../constants/routes'
import PageNotFound from '../pages/PageNotFound/page-not-found'
import RootLayout from '../pages/RootLayout/root-layout'
import RootErrorBoundry from '../pages/RootErrorBoundry/root-error-boundry'
import Login from '../pages/Login/Login'
import Dashboard from '../pages/Dashboard/Dashboard'

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <RootErrorBoundry />,
    children: [
      { index: true, element: <Login /> },
      { path: routePaths.DASHBOARD, element: <Dashboard /> }, // Dashboard route
      { path: '*', element: <PageNotFound /> },
    ],
  },
]

export const router = createBrowserRouter(routes)
